import { Box, Tabs, Tab } from "@mui/material";
import { LeadsManagementData } from "../hooks/useLeadsManagementData";
import { colors, typography, spacing } from "../../../../assets/styles/tokens";

interface LeadsMobileStatusTabsProps {
  data: LeadsManagementData;
}

// Same pill-tab look as the desktop LeadsStatusTabs, minus the
// Reject/Report to brand buttons — mobile has no bulk-selection UI on the
// card list, so there's no selection state for those actions to act on
// here; the mobile lead detail drawer has its own single-lead Reject/Report
// buttons instead (see LeadDetailDrawerMobile.tsx).
export default function LeadsMobileStatusTabs({ data }: LeadsMobileStatusTabsProps) {
  const { status, statusTabs, setStatus, isLoading } = data;

  return (
    <Box sx={{ mt: spacing.Spacing.lg.$value, mb: spacing.Spacing.md.$value }}>
      <Tabs
        value={status}
        onChange={(_, value) => setStatus(value)}
        variant="scrollable"
        scrollButtons={false}
        sx={{
          display: "inline-flex",
          maxWidth: "100%",
          minHeight: 0,
          "& .MuiTabs-flexContainer": { gap: spacing.Spacing.xs.$value },
          "& .MuiTab-root": {
            minHeight: 0,
            minWidth: "auto",
            borderRadius: spacing.Radius.md.$value,
            px: spacing.Spacing.lg.$value,
            py: spacing.Spacing.sm.$value,
            fontFamily: typography.Font_Family.$value,
            fontSize: typography.Size.Text.sm.$value,
            lineHeight: typography.Line_height.text.sm.$value,
            fontWeight: typography.Font_weight.Medium.$value,
            letterSpacing: "0%",
            textTransform: "none",
            color: colors.GrayLightMode[500].$value,
            whiteSpace: "nowrap",
          },
          "& .Mui-selected": {
            color: `${colors.Brand[600].$value} !important`,
            backgroundColor: colors.Brand[50].$value,
          },
          "& .MuiTabs-indicator": { display: "none" },
        }}
      >
        <Tab value="All" label="ALL" disabled={isLoading} />
        {statusTabs.map((tab) => (
          <Tab key={tab.key} value={tab.key} label={tab.label.toUpperCase()} disabled={isLoading} />
        ))}
      </Tabs>
    </Box>
  );
}
